import { usePutCheckpointId } from '../api/check-point-api/check-point-api';

export const usePutCheckpointUpdate = (options?: any) => {
  return usePutCheckpointId(options);
};